import clsx from "clsx";
import { XIcon } from "lucide-react";
import { type PropsWithChildren, useState } from "react";

export enum NotificationBannerType {
	INFO,
	WARNING,
	SUCCESS,
	ERROR,
}

const NotificationBanner = ({
	children,
	type = NotificationBannerType.INFO,
}: PropsWithChildren<{
	type?: NotificationBannerType;
}>) => {
	const [isOpen, setIsOpen] = useState(true);

	const colors = [
		"bg-sky-100/60 dark:bg-sky-300/30 border-sky-700/50 dark:border-sky-300",
		"bg-amber-100/60 border-amber-700/50 dark:bg-amber-300/30 dark:border-amber-300",
		"bg-emerald-100/60 border-emerald-700/50 dark:bg-emerald-300/30 dark:border-emerald-300",
		"bg-red-100/60 border-red-700/50 dark:bg-red-300/30 dark:border-red-300",
	];

	if (!isOpen) return null;

	return (
		<div
			className={clsx(
				"mr-auto flex max-w-max items-start justify-between rounded border-l-[3px] px-3.5 py-2 font-medium sm:text-[1.05rem]",
				colors[type],
			)}
		>
			<p>{children}</p>{" "}
			<button onClick={() => setIsOpen(false)} className="-mr-1 ml-2">
				<XIcon size={18} />
			</button>
		</div>
	);
};

export default NotificationBanner;
